import accentColors from './accentColors'
import errorColors from './errorColors'
import infoColors from './infoColors'
import neutralColors from './neutralColors'
import secondaryColors from './secondaryColors'
import successColors from './successColors'
import warningColors from './warningColors'

const baseColors = {
  ...accentColors,
  ...errorColors,
  ...infoColors,
  ...neutralColors,
  ...secondaryColors,
  ...successColors,
  ...warningColors,
}

export default baseColors
